import React from "react";
import HelpDeskAdmin from "../Components/HelpDesk/HelpDeskAdmin";

const HelpDeskAdminPage: React.FC = () => {
  return (
    <div>
      <HelpDeskAdmin />
    </div>
  );
};

export default HelpDeskAdminPage;
